import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.qml = bracketIndenting()
